import * as v from 'valibot';
import Ajax from '../util/ajax';
import { panelUpdated } from '../features/panels/panelsSlice';
import { panelSchema } from '../types/Panel';
export function savePanel(panel, callback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/panel/' + panel.id;
        ajax.post(url, panel, data => {
            const res = v.safeParse(panelSchema, data);
            if (res.success) {
                dispatch(panelUpdated(res.output));
                callback();
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    };
}
